import { fetcher } from '@commenda/utils';

import { getFilingConductorAnalysisJobPath } from './filing-conductor-analysis-paths';
import {
  CheckFilingConductorAnalysisStatusParams,
  FilingConductorAnalysisMutationResult,
  FilingConductorAnalysisStatusResponse,
} from './types';

export async function checkFilingConductorAnalysisStatus({
  jobId,
}: CheckFilingConductorAnalysisStatusParams): Promise<
  FilingConductorAnalysisMutationResult<FilingConductorAnalysisStatusResponse>
> {
  try {
    const response = await fetcher(
      getFilingConductorAnalysisJobPath(jobId, 'status-check'),
      { method: 'POST' }
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to check analysis status',
        status: response.status,
      };
    }
    return {
      success: true,
      data: json as FilingConductorAnalysisStatusResponse,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to check analysis status',
    };
  }
}
